import { useQuery } from 'react-query';
import { Cookies } from 'react-cookie';
import {
  generateIncludeQuery,
  generateURL,
} from 'utilities/hooks/urlGeneration';
import { fetchWrapper } from 'utils/fetchWrapper';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { INFINITE_CACHE_AND_STALE_TIME } from 'constants/index';
import type { SingleApplicationUserResponse } from 'types/ApplicationUser';

const getApplicationUser = (userID: string | undefined | null) => {
  const url = generateURL(
    SPARK_RESOURCE_TYPES.APPLICATION_USERS,
    [generateIncludeQuery(['marketplaceAccounts'])],
    userID
  );
  return fetchWrapper<SingleApplicationUserResponse>({
    url: url,
    method: 'GET',
  });
};

export const useJoinedUser = () => {
  const cookies = new Cookies();
  const userID = cookies.get('userID') as string;
  const response = useQuery({
    queryKey: ['JoinedUser'],
    queryFn: () => getApplicationUser(userID),
    enabled: Boolean(userID),
    ...INFINITE_CACHE_AND_STALE_TIME,
  });

  const user = response.data?.data;
  const marketplaceAccounts = response.data?.included || [];
  return {
    user,
    marketplaceAccounts,
  };
};
